import "./Barbershop.module.css";
import Header from "@/reusable_sections/Header";
import FestivalOverview from "./sections/FestivalOverview";
import AboutUs from "./sections/AboutUs";
import RequestADemo from "./sections/RequestADemo";
import Footer from "@/reusable_sections/Footer";
export default function BarbershopPage() {
  return <div>
      <Header />
      <FestivalOverview />
      <AboutUs />
      <RequestADemo />
      <Footer />
    </div>;
}